/**
 * @generated SignedSource<<c417ffc50ea55de0cb807509cecd334b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_displayInfo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRenderBlurbs_displayInfo">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_displayInfo";
};
export type PdpRespSidebarBlurbs_displayInfo$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_displayInfo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRenderBlurbs_displayInfo"
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "f9c4bd1195fb2bf0c61395e860f8d914";

export default node;
